import React, { useEffect, useState, useLayoutEffect } from "react";
import axios from "axios";
import "./About.css";
//assets
import aboutRec1 from "../../Assets/aboutimg.png";
import aboutRec2 from "../../Assets/Group 4947@2x.png";
import GetApp from "../../Components/GetApp";
import Footer from "../../Layout/Footer";
import Trusted from "../../Components/HomeComp/Trusted";
import Loader from "../../Components/Loader";

const About = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [data, setData] = useState();
  useEffect(async () => {
    const about = await axios.get(
      "https://staging-cms-main.ipurvey.com/about-us"
    );
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([about.data, layout.data]);
  }, []);
  if (data) {
    return (
      <>
        <div className="about_container">
          <div className="about_content">
            <div className="about_left_content1">
              <h4 className="main_about_head">{data[0]?.header?.title_1}</h4>
              <h2 className=" fw-bold about_head">
                {data[0]?.header?.title_2}
              </h2>
              <p className="about_para">{data[0]?.header?.description}</p>
            </div>
            <div className="about_right_content1">
              <img src={aboutRec1} alt="img" />
            </div>
          </div>
          <div className="about_sec2">
            <div className="about_content mt-5 ">
              <div className="about_left_content2">
                <h2 className=""> {data[0]?.body?.title}</h2>
                <p className="">{data[0]?.body?.description}</p>
                <p className="">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam
                </p>
              </div>
              <div className="about_right_content2">
                <img src={aboutRec2} alt="img" />
              </div>
            </div>
          </div>
        </div>
        <Trusted />
        <GetApp data={data[1]} btn head="Get Registered Today!" />
        <Footer data={data[1]} />
      </>
    );
  } else return <Loader />;
};

export default About;
